import BooksPage from './BooksPage';

export default BooksPage;
